module.exports = __webpack_public_path__ + "img/21-Menstrual problems.fb0e51da.png";